module.exports = __webpack_public_path__ + "static/media/3 12 Tulleord Knain er feil.f6f21bda.mp3";